import React from 'react';
import './svg.css';

const PlusIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.1452 10.6003H3.85352" stroke="#08081B" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M10 4.45459V16.7463" stroke="#08081B" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
  )
}

export default PlusIcon;